export function enablePlatformLogin() {
  return localStorage.getItem("platformVariant") == "B";
}